<template>
  <div>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap class="mb-5">
        <v-flex xs12>
          <div class="text-xs-center">
            <h1 class="mb-4">online loan enquiry</h1>
            <v-fade-transition>
              <tumi-avatar v-show="isReady"></tumi-avatar>
            </v-fade-transition>
          </div>
        </v-flex>
        <v-flex xs12 md8 offset-md2>
          <v-fade-transition>
            <div class="message-wrapper" v-show="isReady">
              <vue-typed-js
                :strings="['We’re nearly there.<br/>' + 'Please confirm you are who you say you are by answering a few questions.  (this protects you and us)']"
                :typeSpeed="15"
              >
                <p class="typing message mb-0" v-show="valid && !loadingScreen"></p>
              </vue-typed-js>
              <div v-show="loadingScreen">
                <p class="message">Sit tight, we’ll be with you in a bit!<br/>
                  We’re just verifying your details and this can take up to a minute.
                </p>
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                      <stop stop-color="#77787b" stop-opacity="0" offset="0%"></stop>
                      <stop stop-color="#77787b" stop-opacity=".631" offset="63.146%"></stop>
                      <stop stop-color="#77787b" offset="100%"></stop>
                    </linearGradient>
                  </defs>
                  <g fill="none" fill-rule="evenodd">
                    <g transform="translate(1 1)">
                      <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 18 18"
                          to="360 18 18"
                          dur="0.9s"
                          repeatCount="indefinite"></animateTransform>
                      </path>
                      <circle fill="#fff" cx="36" cy="18" r="1">
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 18 18"
                          to="360 18 18"
                          dur="0.9s"
                          repeatCount="indefinite"></animateTransform>
                      </circle>
                    </g>
                  </g>
                </svg>
              </div>
              <p v-show="!valid && !loadingScreen" v-html="errorMessage" class="message mb-0">
                Oops it seems there’s a problem.<br/>
                We have sent an email to our support team and they’ll be in touch shortly.
              </p>
            </div>
          </v-fade-transition>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-fade-transition v-if="questionStatusCode != 'TSCSL'">
            <v-form ref="form" v-show="formReady" v-model="valid" lazy-validation class="white--text">
              <v-layout row wrap class="mb-5">
                <v-flex xs12 md8 offset-md2 v-for="question in questionData" v-bind:key="question.question_number" light>

                  <v-text-field color="white"
                    v-if="question.option_count === 0"
                    v-model="answers[question.question_number]"
                    :label="question.question_text"
                    :rules="[(v) => !!v || 'Please fill in a value']"
                    required
                  />

                  <v-select
                    v-if="question.option_count > 0"
                    v-model="answers[question.question_number]"
                    :items="question.option_data"
                    :label="question.question_text"
                    :rules="[(v) => !!v || 'Please select an option']"
                    item-text="optionText"
                    item-value="option_number"
                    color="white"
                    required
                    light
                    appendIcon="keyboard_arrow_down">
                    <template slot="data">
                      <div style="background: black">
                        HELLO?
                      </div>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>

              <hr class="my-5 hidden-sm-and-down">
              <p v-if="!isError" class="refresh">
                <a @click.prevent="refresh" href="javascript:void(0)" class="submit-button">
                  <img v-if="!refreshing" src="/img/icons/refresh_24px.png" class="refresh-img" alt="refresh">
                  <v-progress-circular v-if="refreshing" size="20" :value="40" :indeterminate="refreshing"></v-progress-circular>
                   Refresh question ({{ attempts }} of {{ maxAttempts }})
                </a>
              </p>
              <v-layout row wrap class="mt-5">
                <v-flex xs12 mb-5>

                  <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" v-if="loadingScreen" class="button-loader">
                    <defs>
                      <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                        <stop stop-color="#77787b" stop-opacity="0" offset="0%"></stop>
                        <stop stop-color="#77787b" stop-opacity=".631" offset="63.146%"></stop>
                        <stop stop-color="#77787b" offset="100%"></stop>
                      </linearGradient>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                      <g transform="translate(1 1)">
                        <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
                          <animateTransform
                            attributeName="transform"
                            type="rotate"
                            from="0 18 18"
                            to="360 18 18"
                            dur="0.9s"
                            repeatCount="indefinite"></animateTransform>
                        </path>
                        <circle fill="#fff" cx="36" cy="18" r="1">
                          <animateTransform
                            attributeName="transform"
                            type="rotate"
                            from="0 18 18"
                            to="360 18 18"
                            dur="0.9s"
                            repeatCount="indefinite"></animateTransform>
                        </circle>
                      </g>
                    </g>
                  </svg>
                  <v-btn v-if="!loadingScreen && isError"
                    class="submit-button"
                    @click="showStepOne"
                  >
                    Retry
                  </v-btn>
                  <v-btn v-if="!loadingScreen && !isError"
                         class="submit-button"
                         @click="submit"
                  >
                    Confirm
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-fade-transition>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import axios from 'axios'
  import router from '../router'
  import store from '../store'

  // helper to get a displayable message to the user
  function getErrorMessage(err) {
    let responseBody
    responseBody = err.response
    if (!responseBody) {
      responseBody = err
    } else if (err.response.data.errors) {
      if (err.response.data.errors.email) {
        responseBody.message = 'The email address you have provided is already linked to a user profile.<br /><br />Send us an email at <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a> and we will get back to you.'
      } else {
        responseBody.message = err.response.data.errors[Object.keys(err.response.data.errors)[0]][0] // eslint-disable-line
      }
    } else {
      responseBody = err.response.data || responseBody
    }
    return responseBody.message || JSON.stringify(responseBody)
  }

  export default {
    name: 'step1Auth',
    data: () => ({
      valid: true,
      isReady: false,
      formReady: false,
      postalCode: store.postalCode,
      postalCodeRules: [
        v => !!v || 'Please fill in your postal code'
      ],
      marriageStatus: store.marriageStatus,
      marriageStatuses: [
        'Single',
        'Married',
        'Divorced',
        'Never Married'
      ],
      marriageStatusRules: [
        v => !!v || 'Please choose an option'
      ],
      status: '',
      firstName: store.state.firstName,
      errorMessage: '',
      loadingScreen: false,
      questionData: store.state.questionData,
      questionStatusCode: store.state.questionStatusCode,
      answers: [],
      attempts: 1,
      maxAttempts: process.env.VUE_APP_ATTEMPTS,
      refreshing: false,
      isError: false
    }),
    computed: {
      isMaxAttempt() {
        return this.attempts < this.maxAttempts
      }
    },
    methods: {
      showStepOne() {
        console.log('go to step 1')
        router.push({
          path: '/'
        })
      },
      refresh() {
        if (this.refreshing) {
          return
        }
        if (!this.isMaxAttempt) {
          this.isError = true
          this.errorMessage = 'Unfortunately, we still can’t confirm your identity. <br>Please mail us at <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a> and we’ll get back to you.'
        } else {
          this.refreshing = true
          axios.post(`${store.state.apiUrl}/auth/compuscan/fetch_questions`, {
            idNumber: store.state.ID
          }).then(response => {
            if (response.data.message.return_data.status_code === 'TSCKR') {
              this.errorMessage = 'Weird. Your identity information and answers don\'t add up. For support please reach out to us on <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a>'
              this.isError = true
              return
            }
            this.loadingScreen = false
            store.commit('questionData', response.data.message.return_data.question_data)
            this.answers = []
            this.questionData = response.data.message.return_data.question_data
            store.commit('transactionId', response.data.message.return_data.transaction_id)
            this.attempts++
            this.refreshing = false
          }).catch(er => {
            this.loadingScreen = false
            this.valid = false
            this.refreshing = false

            const error = getErrorMessage(er)
            if (error === 'Network Error') {
              this.errorMessage = 'Your connection is taking too long for us to check your info. Please get in touch with our support team at <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a> and we will get back to you.'
              this.isError = true
            } else {
              this.errorMessage = error
              this.isError = true
            }
          }).then(() => {
            this.status = ''
            this.refreshing = false
          })
        }
      },
      submit() {
        this.loadingScreen = true
        if (this.$refs.form.validate()) {
          if (this.attempts <= this.maxAttempts) {
            this.status = 'submitting'
            axios.post(`${store.state.apiUrl}/loans/submit_auth_questions`, {
              answers: this.answers,
              transactionId: store.state.transactionId
            })
              .then(response => {
                this.loadingScreen = false
                store.commit('userId', response.data.message.original.message.user_id)
                store.commit('creditScore', response.data.message.original.message.compuscan_score)
                this.$mixpanel.track('Auth successful', {
                  AuthSucessful: true
                })

                this.$mixpanel.people.set({
                  $CreditScore: response.data.message.original.message.compuscan_score
                })

                this.$mixpanel.track('View success + credit score', {
                  'Lead ID': '',
                  'Credit score': response.data.message.original.message.compuscan_score
                })

                router.push({
                  path: '/complete'
                })
              })
              .catch(err => {
                console.log(err.response)
                this.loadingScreen = false
                this.valid = false
                if (err.response.status === 401) {
                  this.isError = true
                  this.errorMessage = err.response.data.message
                  // this.errorMessage = `We can’t confirm your identity. Please double check your ID number before trying again - ${store.state.ID}.`
                  // this.attempts++

                  if (this.attempts >= this.maxAttempts) {
                    this.errorMessage = 'Unfortunately, we still can’t confirm your identity. <br>Please mail us at <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a> and we’ll get back to you.'
                  } else {
                    if (this.refreshing) {
                      return
                    }
                    this.refreshing = true
                    this.isError = false
                    axios.post(`${store.state.apiUrl}/auth/compuscan/fetch_questions`, {
                      idNumber: store.state.ID
                    })
                      .then(response => {
                        if (response.data.message.return_data.status_code === 'TSCKR') {
                          this.errorMessage = 'Weird. Your identity information and answers don\'t add up. For support please reach out to us on <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a>'
                          this.isError = true
                          return
                        }
                        this.loadingScreen = false
                        store.commit('questionData', response.data.message.return_data.question_data)
                        this.answers = []
                        this.questionData = response.data.message.return_data.question_data
                        store.commit('transactionId', response.data.message.return_data.transaction_id)
                        this.refreshing = false
                        this.attempts++
                      })
                      .catch(er => {
                        this.loadingScreen = false
                        this.valid = false
                        this.refreshing = false

                        const error = getErrorMessage(er)
                        if (error === 'Network Error') {
                          this.errorMessage = 'Your connection is taking too long for us to check your info. Please get in touch with our support team at <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a> and we will get back to you.'
                          this.isError = true
                        } else {
                          this.errorMessage = error
                          this.isError = true
                        }

                        // this.$mixpanel.track("Auth failed - " + this.errorMessage);
                      })
                      .then(() => {
                        this.status = ''
                        this.refreshing = false
                      })
                  }
                } else {
                  const error = getErrorMessage(err)
                  if (error === 'Network Error') {
                    this.errorMessage = 'Your connection is taking too long for us to check your info. Please get in touch with our support team at <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a> and we will get back to you.'
                    this.isError = true
                  } else {
                    this.errorMessage = error
                    this.isError = true
                  }
                }

                // this.$mixpanel.track("Auth failed - " + this.errorMessage);
              })
              .then(() => {
                this.status = ''
              })
          } else {
            this.isError = true
            this.loadingScreen = false
            this.errorMessage = 'Unfortunately, we still can’t confirm your identity. <br>Please mail us at <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a> and we’ll get back to you.'
          }
        } else {
          this.loadingScreen = false
          this.errorMessage = 'We’re nearly there.<br/>Please confirm you are who you say you are by answering these two questions.  (this protects you and us)'
        }
      },
      onRefresh() {
        router.push({
          path: '/'
        })
      }
    },
    mounted() {
      window.addEventListener('unload', this.onRefresh)
      setTimeout(() => {
        this.isReady = true
      }, 500)
      setTimeout(() => {
        this.formReady = true
      }, 1500)

      if (store.state.questionStatusCode === 'TSCSL') {
        this.isError = true
        this.loadingScreen = false
        this.valid = false
        this.errorMessage = 'Unfortunately you have exceeded your number of attempts today, please try again tomorrow.'
      }

      if (store.state.questionStatusCode === 'TSCKR') {
        this.isError = true
        this.loadingScreen = false
        this.valid = false
        this.errorMessage = 'Weird. Your identity information and answers don\'t add up. For support please reach out to us on <a style="text-decoration: underline; color: #1eb887;" href="mailto: support@virginmoney.co.za">support@virginmoney.co.za</a>'
      }
      // this.$mixpanel.track('Page: Auth')
    }
  }
</script>

<style scoped>
  .refresh{
    color: white;
    text-align: right;
  }
  .refresh a {
    color: white;
  }
  .refresh-img {
    width: 1rem;
    margin-bottom: -2px;
  }
</style>
